// packages
import { Component, h } from 'preact';

// components
import CandidateRow from './components/CandidateRow';
import Contest from './components/Contest';
import YourRaces from './components/YourRaces';
import Portal from './components/Portal';

import textBalancer from 'text-balancer';

import { determineContestTitle } from './election-utils';
import { RESULTS_IN_USE } from './endpoints';
import getJSON from './utils/get-json';

type State = {
  data: { [key: string]: any };
};

class App extends Component<{}, State> {
  constructor() {
    super();

    this.state = {
      data: [],
    };

    this.fetchData = this.fetchData.bind(this);
    this.handleLoad = this.handleLoad.bind(this);
  }

  fetchData() {
    getJSON(RESULTS_IN_USE).then(data => this.setState({ data }));
  }

  componentDidMount() {
    this.fetchData();
    window.addEventListener('load', this.handleLoad);
  }

  componentWillUnmount() {}

  componentDidUpdate() {}

  handleLoad() {
    textBalancer.balanceText();
  }

  render() {
    const { notes } = this.props;
    const { data } = this.state;

    return (
      <div class="results">
        <Portal
          node={document.getElementById('lookup-select')}
          ref={ref => (this._yourPortal = ref)}
        >
          <YourRaces notes={notes} contests={data} />
        </Portal>

        <Portal
          node={document.querySelector('#governor .contests')}
          ref={ref => (this._usPortal = ref)}
        >
          <div class="office__contests seat__contests-single">
            {data
              .filter(contest => contest.office === 'Governor')
              .map(contest => (
                <Contest
                  key={contest.id}
                  contest={contest}
                  columnCount={CandidateRow.columnCount}
                  contestTitle={determineContestTitle(
                    data.filter(
                      item => item.office_slug === contest.office_slug
                    )[0]
                  )}
                  notes={notes.filter(
                    item => item.type === contest.office_slug
                  )}
                  tableHeader={CandidateRow.Header}
                  renderCandidate={(candidate, idx) => (
                    <CandidateRow
                      key={candidate.id}
                      ballotName={candidate.name}
                      candidateId={candidate.id}
                      isIncumbent={candidate.is_incumbent}
                      party={candidate.party}
                    />
                  )}
                />
              ))}
          </div>
        </Portal>

        <Portal
          node={document.querySelector('#attorney-general .contests')}
          ref={ref => (this._usPortal = ref)}
        >
          <div class="office__contests seat__contests-single">
            {data
              .filter(contest => contest.office === 'Attorney General')
              .map(contest => (
                <Contest
                  key={contest.id}
                  contest={contest}
                  columnCount={CandidateRow.columnCount}
                  contestTitle={determineContestTitle(
                    data.filter(
                      item => item.office_slug === contest.office_slug
                    )[0]
                  )}
                  tableHeader={CandidateRow.Header}
                  notes={notes.filter(
                    item => item.type === contest.office_slug
                  )}
                  renderCandidate={(candidate, idx) => (
                    <CandidateRow
                      key={candidate.id}
                      ballotName={candidate.name}
                      candidateId={candidate.id}
                      isIncumbent={candidate.is_incumbent}
                      party={candidate.party}
                    />
                  )}
                />
              ))}
          </div>
        </Portal>

        <Portal
          node={document.querySelector('#lieutenant-governor .contests')}
          ref={ref => (this._usPortal = ref)}
        >
          <div class="office__contests seat__contests-single">
            {data
              .filter(contest => contest.office === 'Lieutenant Governor')
              .map(contest => (
                <Contest
                  key={contest.id}
                  contest={contest}
                  columnCount={CandidateRow.columnCount}
                  contestTitle={determineContestTitle(
                    data.filter(
                      item => item.office_slug === contest.office_slug
                    )[0]
                  )}
                  tableHeader={CandidateRow.Header}
                  notes={notes.filter(
                    item => item.type === contest.office_slug
                  )}
                  renderCandidate={(candidate, idx) => (
                    <CandidateRow
                      key={candidate.id}
                      ballotName={candidate.name}
                      candidateId={candidate.id}
                      isIncumbent={candidate.is_incumbent}
                      party={candidate.party}
                    />
                  )}
                />
              ))}
          </div>
        </Portal>

        <Portal
          node={document.querySelector('#land-commissioner .contests')}
          ref={ref => (this._usPortal = ref)}
        >
          <div class="office__contests seat__contests-single">
            {data
              .filter(contest => contest.office === 'Land Commissioner')
              .map(contest => (
                <Contest
                  key={contest.id}
                  contest={contest}
                  columnCount={CandidateRow.columnCount}
                  contestTitle={determineContestTitle(
                    data.filter(
                      item => item.office_slug === contest.office_slug
                    )[0]
                  )}
                  tableHeader={CandidateRow.Header}
                  notes={notes.filter(
                    item => item.type === contest.office_slug
                  )}
                  renderCandidate={(candidate, idx) => (
                    <CandidateRow
                      key={candidate.id}
                      ballotName={candidate.name}
                      candidateId={candidate.id}
                      isIncumbent={candidate.is_incumbent}
                      party={candidate.party}
                    />
                  )}
                />
              ))}
          </div>
        </Portal>

        <Portal
          node={document.querySelector('#agriculture-commissioner .contests')}
          ref={ref => (this._usPortal = ref)}
        >
          <div class="office__contests seat__contests-single">
            {data
              .filter(contest => contest.office === 'Agriculture Commissioner')
              .map(contest => (
                <Contest
                  key={contest.id}
                  contest={contest}
                  columnCount={CandidateRow.columnCount}
                  contestTitle={determineContestTitle(
                    data.filter(
                      item => item.office_slug === contest.office_slug
                    )[0]
                  )}
                  tableHeader={CandidateRow.Header}
                  notes={notes.filter(
                    item => item.type === contest.office_slug
                  )}
                  renderCandidate={(candidate, idx) => (
                    <CandidateRow
                      key={candidate.id}
                      ballotName={candidate.name}
                      candidateId={candidate.id}
                      isIncumbent={candidate.is_incumbent}
                      party={candidate.party}
                    />
                  )}
                />
              ))}
          </div>
        </Portal>

        <Portal
          node={document.querySelector('#comptroller .contests')}
          ref={ref => (this._usPortal = ref)}
        >
          <div class="office__contests seat__contests-single">
            {data
              .filter(contest => contest.office === 'Comptroller')
              .map(contest => (
                <Contest
                  key={contest.id}
                  contest={contest}
                  columnCount={CandidateRow.columnCount}
                  contestTitle={determineContestTitle(
                    data.filter(
                      item => item.office_slug === contest.office_slug
                    )[0]
                  )}
                  tableHeader={CandidateRow.Header}
                  notes={notes.filter(
                    item => item.type === contest.office_slug
                  )}
                  renderCandidate={(candidate, idx) => (
                    <CandidateRow
                      key={candidate.id}
                      ballotName={candidate.name}
                      candidateId={candidate.id}
                      isIncumbent={candidate.is_incumbent}
                      party={candidate.party}
                    />
                  )}
                />
              ))}
          </div>
        </Portal>

        <Portal
          node={document.querySelector(
            '#railroad-commission-of-texas .contests'
          )}
          ref={ref => (this._supremePortal = ref)}
        >
          <div class="office__contests seat__contests-single">
            {data
              .filter(contest => contest.office === 'Texas Railroad Commission')
              .map(contest => (
                <Contest
                  key={contest.id}
                  contest={contest}
                  columnCount={CandidateRow.columnCount}
                  contestTitle={determineContestTitle(
                    data.filter(
                      item => item.office_slug === contest.office_slug
                    )[0]
                  )}
                  tableHeader={CandidateRow.Header}
                  notes={notes.filter(
                    item => item.type === contest.office_slug
                  )}
                  renderCandidate={(candidate, idx) => (
                    <CandidateRow
                      key={candidate.id}
                      ballotName={candidate.name}
                      candidateId={candidate.id}
                      isIncumbent={candidate.is_incumbent}
                      party={candidate.party}
                    />
                  )}
                />
              ))}
          </div>
        </Portal>

        <Portal
          node={document.querySelector('#texas-supreme-court .contests')}
          ref={ref => (this._supremePortal = ref)}
        >
          <div class="office__contests seat__contests-double">
            {data
              .filter(contest => contest.office === 'Texas Supreme Court')
              .map(contest => (
                <Contest
                  key={contest.id}
                  contest={contest}
                  columnCount={CandidateRow.columnCount}
                  contestTitle={determineContestTitle(
                    data.filter(
                      item => item.office_slug === contest.office_slug
                    )[0]
                  )}
                  tableHeader={CandidateRow.Header}
                  notes={notes.filter(
                    item => item.type === contest.office_slug
                  )}
                  renderCandidate={(candidate, idx) => (
                    <CandidateRow
                      key={candidate.id}
                      ballotName={candidate.name}
                      candidateId={candidate.id}
                      isIncumbent={candidate.is_incumbent}
                      party={candidate.party}
                    />
                  )}
                />
              ))}
          </div>
        </Portal>

        <Portal
          node={document.querySelector(
            '#texas-court-of-criminal-appeals .contests'
          )}
          ref={ref => (this._supremePortal = ref)}
        >
          <div class="office__contests seat__contests-double">
            {data
              .filter(
                contest => contest.office === 'Texas Court of Criminal Appeals'
              )
              .map(contest => (
                <Contest
                  key={contest.id}
                  contest={contest}
                  columnCount={CandidateRow.columnCount}
                  contestTitle={determineContestTitle(
                    data.filter(
                      item => item.office_slug === contest.office_slug
                    )[0]
                  )}
                  tableHeader={CandidateRow.Header}
                  notes={notes.filter(
                    item => item.type === contest.office_slug
                  )}
                  renderCandidate={(candidate, idx) => (
                    <CandidateRow
                      key={candidate.id}
                      ballotName={candidate.name}
                      candidateId={candidate.id}
                      isIncumbent={candidate.is_incumbent}
                      party={candidate.party}
                    />
                  )}
                />
              ))}
          </div>
        </Portal>

        <Portal
          node={document.querySelector('#us-house .contests')}
          ref={ref => (this._usPortal = ref)}
        >
          <div class="office__contests seat__contests-double">
            {data
              .filter(contest => contest.office === 'U.S. House')
              .map(contest => (
                <Contest
                  key={contest.id}
                  contest={contest}
                  columnCount={CandidateRow.columnCount}
                  contestTitle={determineContestTitle(
                    data.filter(
                      item => item.office_slug === contest.office_slug
                    )[0]
                  )}
                  tableHeader={CandidateRow.Header}
                  notes={notes.filter(
                    item => item.type === contest.office_slug
                  )}
                  renderCandidate={(candidate, idx) => (
                    <CandidateRow
                      key={candidate.id}
                      ballotName={candidate.name}
                      candidateId={candidate.id}
                      isIncumbent={candidate.is_incumbent}
                      party={candidate.party}
                    />
                  )}
                />
              ))}
          </div>
        </Portal>

        <Portal
          node={document.querySelector('#state-board-of-education .contests')}
          ref={ref => (this._sboePortal = ref)}
        >
          <div class="office__contests seat__contests-double">
            {data
              .filter(contest => contest.office === 'State Board of Education')
              .map(contest => (
                <Contest
                  key={contest.id}
                  contest={contest}
                  columnCount={CandidateRow.columnCount}
                  contestTitle={determineContestTitle(
                    data.filter(
                      item => item.office_slug === contest.office_slug
                    )[0]
                  )}
                  tableHeader={CandidateRow.Header}
                  notes={notes.filter(
                    item => item.type === contest.office_slug
                  )}
                  renderCandidate={(candidate, idx) => (
                    <CandidateRow
                      key={candidate.id}
                      ballotName={candidate.name}
                      candidateId={candidate.id}
                      isIncumbent={candidate.is_incumbent}
                      party={candidate.party}
                    />
                  )}
                />
              ))}
          </div>
        </Portal>
        <Portal
          node={document.querySelector('#texas-senate .contests')}
          ref={ref => (this._senatePortal = ref)}
        >
          <div class="office__contests seat__contests-double">
            {data
              .filter(contest => contest.office === 'Texas Senate')
              .map(contest => (
                <Contest
                  key={contest.id}
                  contest={contest}
                  columnCount={CandidateRow.columnCount}
                  contestTitle={determineContestTitle(
                    data.filter(
                      item => item.office_slug === contest.office_slug
                    )[0]
                  )}
                  tableHeader={CandidateRow.Header}
                  notes={notes.filter(
                    item => item.type === contest.office_slug
                  )}
                  renderCandidate={(candidate, idx) => (
                    <CandidateRow
                      key={candidate.id}
                      ballotName={candidate.name}
                      candidateId={candidate.id}
                      isIncumbent={candidate.is_incumbent}
                      party={candidate.party}
                    />
                  )}
                />
              ))}
          </div>
        </Portal>

        <Portal
          node={document.querySelector('#texas-house .contests')}
          ref={ref => (this._housePortal = ref)}
        >
          <div class="office__contests seat__contests-double">
            {data
              .filter(contest => contest.office === 'Texas House')
              .map(contest => (
                <Contest
                  key={contest.id}
                  contest={contest}
                  columnCount={CandidateRow.columnCount}
                  contestTitle={determineContestTitle(
                    data.filter(
                      item => item.office_slug === contest.office_slug
                    )[0]
                  )}
                  tableHeader={CandidateRow.Header}
                  notes={notes.filter(
                    item => item.type === contest.office_slug
                  )}
                  renderCandidate={(candidate, idx) => (
                    <CandidateRow
                      key={candidate.id}
                      ballotName={candidate.name}
                      candidateId={candidate.id}
                      isIncumbent={candidate.is_incumbent}
                      party={candidate.party}
                    />
                  )}
                />
              ))}
          </div>
        </Portal>
      </div>
    );
  }
}

export default App;
